import Logo from '@/components/atoms/Logo';
import NewPasswordForm from '@/components/template/forms/NewPasswordForm';
import Spinner from '@/components/atoms/Spinner';
import { useAuth } from '@/hooks/useAuth';
import routeNames from '@/routes/routeNames';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { notify } from '@/helpers';

export const NewPassword = () => {
  const navigate = useNavigate();
  const { resetPassword, verifyResetPasswordToken } = useAuth();
  const [loading, setLoading] = useState(true);

  const verifyToken = async (token: string) => {
    try {
      const response = await verifyResetPasswordToken(token);
      if (response?.data && !response.data?.valid) {
        setLoading(false);
        navigate('/404', { replace: true });
      }
    } catch (error) {
      notify('error', (error as Error)?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (token) {
      verifyToken(token);
    } else {
      setLoading(false);
      navigate('/404', { replace: true });
    }
  }, []);

  return (
    <div className='h-screen flex justify-center items-center bg-white'>
      {loading ? (
        <Spinner size={50} color={'#242263'} />
      ) : (
        <div className='w-[500px] px-5 rounded-md pb-5 pt-3'>
          <div className='flex flex-col items-center justify-center mb-6'>
            <Link
              to={'/'}
              className='flex flex-col items-center justify-center'
            >
              <Logo size='lg' />
              <h5>
                <span className='font-bold text-primary'>Spark</span>
                Hub
              </h5>
            </Link>
            <p className='text-center w-[70%] mt-5'>
              Enter your new password and confirm it.
            </p>
          </div>
          <NewPasswordForm handleNewPassword={resetPassword} />
          <p className='text-center underline text-gray-400 mt-5'>
            <Link to={routeNames.authentication.login}>Back to Login</Link>
          </p>
        </div>
      )}
    </div>
  );
};
